import { useEffect, useRef, useState } from 'react';
import axiosInstance from '@/api/axiosInstance';
import { dropToken, readToken } from '@/lib/auth/session';
import { ApiError, setAuthToken } from '@/lib/http';
import { useAuthStore } from '@/stores/authStore';
import { meService } from '../services';

export const useRestoreSession = (): boolean => {
  const signIn = useAuthStore((state) => state.signIn);
  const [resolved, setResolved] = useState(() => readToken() === null);
  const started = useRef(false);

  useEffect(() => {
    if (resolved || started.current) return;
    started.current = true;

    const token = readToken();
    if (!token) {
      setResolved(true);
      return;
    }

    setAuthToken(axiosInstance, token);
    meService()
      .then((data) => signIn(data.admin))
      .catch((error: unknown) => {
        if (error instanceof ApiError && error.kind === 'unauthorized') dropToken();
      })
      .finally(() => setResolved(true));
  }, [resolved, signIn]);

  return resolved;
};
